import { useMutation } from "@apollo/client";
import type {
  DeleteProjectInput as DeleteProjectInputType,
  DeleteProjectPayload,
} from "@casey/db-types";
import { DELETE_PROJECT, GET_ORGANIZATION_PROJECTS } from "../gql";

interface DeleteProjectVariables {
  input: DeleteProjectInputType;
}

interface DeleteProjectResponse {
  deleteProject: DeleteProjectPayload;
}

export function useDeleteProject() {
  const [deleteProjectMutation, { data, loading, error }] = useMutation<
    DeleteProjectResponse,
    DeleteProjectVariables
  >(DELETE_PROJECT, {
    refetchQueries: [{ query: GET_ORGANIZATION_PROJECTS }],
  });

  const deleteProject = async (projectId: string) => {
    try {
      const result = await deleteProjectMutation({
        variables: {
          input: {
            id: projectId,
          },
        },
      });

      return result.data?.deleteProject?.project;
    } catch (err) {
      console.error("Error deleting project:", err);
      throw err;
    }
  };

  return {
    deleteProject,
    data: data?.deleteProject?.project,
    loading,
    error,
  };
}
